import { moment } from "@/services/vue-moment";

export var date = d => {
  return new Promise(resolve => {
    resolve(moment(d).utc());
  });
};

export default {
  date
};
